<img alt="shared-img" *ngIf="fileUrl" style="height: 500px; width: auto; margin-top: 32px; margin-left: 32px" [src]="fileUrl" />
